// #region Imports
import { Tooltip } from '@radix-ui/themes';
import { Provider as TooltipProvider } from '@radix-ui/react-tooltip';
import { FaCopy, FaCheck } from 'react-icons/fa';
import { useAZCopy } from './useAZCopy';
import type { AZCopyProps } from './AZCopy.types';
import './AZCopy.css';
import { AZButton } from '../AZButton';
// #endregion

// #region Component
/**
 * Icon button that copies text to the clipboard.
 * Shows a success indicator after copying.
 *
 * @example
 * <AZCopy text="some-value" onCopy={(err) => err && console.error(err)} />
 */
const AZCopy = ({ text, color, onCopy }: AZCopyProps) => {
  const { isCopied, handleCopy } = useAZCopy(onCopy ? { onCopy } : {});
  const tooltipLabel = isCopied ? 'Copied!' : 'Copy';

  // #region Interface
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip content={tooltipLabel} open={isCopied || undefined}>
        <AZButton
          variant="ghost"
          size="sm"
          type="button"
          description="Copy text"
          aria-label={tooltipLabel}
          className={isCopied ? 'az-copy-copied' : undefined}
          style={color ? { color } : undefined}
          onClick={(e) => handleCopy(text, e)}
        >
          {isCopied ? <FaCheck aria-hidden="true" /> : <FaCopy aria-hidden="true" />}
        </AZButton>
      </Tooltip>
    </TooltipProvider>
  );
  // #endregion
};
// #endregion

// #region Display Name
AZCopy.displayName = 'AZCopy';
// #endregion

export { AZCopy };
